export default "__VITE_ASSET__eV3bHagW__"